/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Produkt Toolbar
 *
 */
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";


import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import { Icon } from '../../partials/Icons';
class ProductToolbar extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { path, favoredList, online, iPhone, appModus, currentContainer } = this.props.app;
        const { height, node } = this.props;
        //const { currentGroup } = this.props.portfolio;

        const dialog = utils.getDialogByPath(path);

        const isFavored = utils.checkFavored(path);

        const isGroupImage = false;
        //const isGroupImage = utils.isProductGroupImage(dialog.product, currentGroup);

        const productURL = utils.getProductURL(node);

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const Button = ({ type, icon, label }) => {

            const pdfFilter = (type === "price") ? node.filter((f) => utils.checkPriceListPDF(f.name)) : [];
            // Toolbar-Item/Button nur anzeigen, wenn auch eine Preisliste existiert!
            if (type === "price" && pdfFilter.length === 0) return null;

            const onClick = (type) => {

                const callViewPDF = (viewOnly) => {
                    if (pdfFilter.length > 0) {
                        const pdf = pdfFilter[0];
                        const sID = `${currentContainer}_${utils.cyrb53(pdf.path)}_${pdf.name}`;

                        cordova.viewPDF(sID, viewOnly);
                    }
                }

                const viewWebsite = () => {
                    const metaFilter = node.filter(d => d.name === 'meta.json')
                    if (metaFilter.length > 0) {
                        console.log('URL:', metaFilter[0].meta.url)

                        cordova.viewWebsite(metaFilter[0].meta.url)
                    }
                }

                const setFavored = () => {
                    let newFavoredList = favoredList;
                    if (isFavored) {
                        newFavoredList = favoredList.filter((value) => value !== path); // löschen
                    } else {
                        newFavoredList.push(path); // neu anlegen
                    }
                    // neue Favoritenliste im REDUS-Store speichern
                    this.props.setFavoredList(newFavoredList); // appAction.js

                    // neue Favoritenliste in IndexedDB speichern
                    cordova.writeLocalJSON(currentContainer, 'favored.json', newFavoredList);
                }

                const setGroupImage = () => {
                    const groupPath = path.replace(`/${dialog.product}`, '');

                    this.props.uploadJSON(groupPath, 'groupimage.json', [dialog.product], () => {
                        console.log('uploadJSON(success)');
                        this.props.scanPortfolio(dialog.portfolio);
                    }, (error) => {
                        console.log('uploadJSON(error)', error);
                    })
                }

                if (type === "share" && online) {
                    cordova.sendMail(currentContainer, path)
                }
                if (type === "world" && online) { viewWebsite() }

                if (type === "favored") { setFavored() }
                if (type === "groupi") { setGroupImage() }
                if (type === "price") { callViewPDF(false) }
                if (type === "download") { callViewPDF(true) }
                if (type === "edit") { this.props.setModalDialog('ProductModal', 'update') }
                if (type === "delete") { this.props.setModalDialog('ProductModal', 'delete') }
                if (type === "update") { this.props.setModalDialog('ProductDetailsModal', 'update') }
                if (type === "filter") { this.props.setModalDialog('ProductTagsModal', 'update') }
            }

            const renderImage = () => {
                const className = "w-1/4 items-center justify-right focus:outline-none";

                return (
                    <div style={utils.getStyleHeight(height, .8, .8, .8)} className={className} onClick={(e) => onClick(type)}>
                        <Icon type={icon} width={height * .67} height={height * .67} />
                    </div>
                )
            }

            const renderLabel = () => {
                let className = "w-3/4 items-center justify-left whitespace-no-wrap overflow-x-auto overflow-y-hidden";

                const getStyle = () => { return utils.getStyleHeight(height, 0.9, 0.9, 0.38); };

                return (<div style={getStyle()} className={className} onClick={() => onClick(type)} >{label}</div>);
            }

            // ###############################################################
            // Button
            // ###############################################################
            let className = "w-full flex justify-center items-center font-normal";

            if (['world', 'share'].includes(type) && !online) {
                className += " opacity-25";
            }

            const style = Object.assign((type === "price") ? { color: 'rgb(221,76,70)' } : {}, utils.getStyleHeight(height, 1.1, 1, 1));

            // Beim letzten Toolbar-Item/Button kein Border zeigen
            if (type !== "price") { className += " border-b border-black" }

            return (
                <div className={className} style={style}>
                    {renderImage()}
                    {renderLabel()}
                </div>
            );
        }

        const renderToolbarAdmin = () => {
            return (
                <div className="w-full h-full flex flex-col justify-start items-center">
                    <Button key={0} type="edit" icon="edit2" label="Titel ändern"></Button>
                    <Button key={1} type="update" icon="settings" label="Eigenschaften"></Button>
                    <Button key={2} type="filter" icon="filter" label="Filter / Schlagwörter"></Button>
                    <Button key={3} type="delete" icon="delete" label="Produkt löschen"></Button>
                    <Button key={4} type="groupi" icon={isGroupImage ? 'star_filled' : 'star_spikes'} label="Gruppenbild"></Button>
                </div>
            )
        }

        const renderToolbarUser = () => {
            const canShare = window['cordova'] || navigator.canShare;

            return (
                <div className="w-full h-full flex flex-col justify-start items-center">
                    <Button key={0} type="favored" icon={isFavored ? 'star_filled' : 'star_spikes'} label="Favorit"></Button>
                    {productURL && <Button key={1} type="world" icon="world" label="Produkt online"></Button>}
                    {canShare && <Button key={2} type="share" icon="share" label="Dokumente teilen"></Button>}
                    <Button key={3} type="price" icon="euro" label="Preisliste" ></Button>
                </div>
            )
        }

        // ==========================================================================
        //
        // MAIN RENDER
        //
        // ==========================================================================

        return (
            <div
                className={"w-full h-full flex flex-col justify-start text-left overflow-y-auto overflow-x-hidden " + (iPhone ? "px-2" : "px-2")}>
                <div className="w-full flex">
                    {appModus === 'Admin' ? renderToolbarAdmin() : renderToolbarUser()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductToolbar);